var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var controllers;
    (function (controllers) {
        var FileUploadModalController = /** @class */ (function (_super) {
            __extends(FileUploadModalController, _super);
            function FileUploadModalController($scope, $timeout, documentIds, process, documentConfiguration, systemDocumentConfiguration, uniqueIdentifier, model, fileUploadDownloadService, processDocumentService, close) {
                var _this = _super.call(this, $scope, close) || this;
                _this.$timeout = $timeout;
                _this.fileUploadDownloadService = fileUploadDownloadService;
                _this.processDocumentService = processDocumentService;
                _this.scope = $scope;
                _this.scope.documentIds = documentIds;
                _this.scope.process = process;
                _this.scope.documentConfiguration = documentConfiguration;
                _this.scope.systemDocumentConfiguration = systemDocumentConfiguration;
                _this.scope.uniqueIdentifier = uniqueIdentifier;
                _this.scope.model = model;
                _this.scope.uploadFiles = function (files) { return _this.uploadFiles(files); };
                _this.scope.removeDocument = function (index) { return _this.removeDocument(index); };
                _this.scope.canSave = function () { return _this.canSave(); };
                _this.scope.save = function () { return _this.save(); };
                _this.initialize();
                return _this;
            }
            FileUploadModalController.prototype.save = function () {
                for (var i = 0; i < this.scope.model.documents.length; i++) {
                    this.scope.documentMetadataModel.updateDocumentDto(this.scope.model.documents[i]);
                }
                this.dismissModal(true);
            };
            FileUploadModalController.prototype.initialize = function () {
                var _this = this;
                this.scope.myId = warsApp.services.UtilityService.generateGuidComb();
                this.scope.model.documents = [];
                if (this.scope.documentIds) {
                    for (var i = 0; i < this.scope.documentIds.length; i++) {
                        var document = this.processDocumentService.getDocumentById(this.scope.process, this.scope.documentIds[i]);
                        if (document) {
                            this.scope.model.documents.push(document);
                            // If multiple files all have the same metadata so don't worry about which document to use to initialize
                            this.scope.documentMetadataModel = new warsApp.models.DocumentMetadataModel(document);
                        }
                    }
                }
                if (!this.scope.documentMetadataModel) {
                    this.scope.documentMetadataModel = new warsApp.models.DocumentMetadataModel(undefined);
                }
                this.scope.acceptsText = this.scope.documentConfiguration.overrideSystemDocumentAccepts
                    ? this.scope.documentConfiguration.documentAccepts
                    : this.scope.systemDocumentConfiguration.documentAccepts;
                this.scope.documentTypeContext = new warsApp.models.CodeDropDownContext();
                this.scope.documentTypeContext.includeSpecifiedOptionsOnly = Enumerable.from(this.scope.documentConfiguration.myAvailableDocumentTypes)
                    .where(function (i) { return i.isAvailable; })
                    .select(function (i) { return i.mySystemCode.uniqueIdentifier; })
                    .toArray();
                this.scope.showDocumentTypeDropDown = this.scope.documentConfiguration.includeDocumentType &&
                    Enumerable.from(this.scope.documentConfiguration.myAvailableDocumentTypes).count(function (i) { return i.isAvailable; }) > 1;
                // If no metadata then go ahead and open browsers file upload window
                if (!this.areInputsDisplayed()) {
                    this.$timeout(function () {
                        angular.element("#" + _this.scope.myId).triggerHandler('click');
                    });
                }
            };
            FileUploadModalController.prototype.areInputsDisplayed = function () {
                var docConfig = this.scope.documentConfiguration;
                return docConfig.includeDocumentComment ||
                    (docConfig.documentSecurity === 2 /* CanBeMarkedSecured */ && this.scope.process.canSecureDocment[this.scope.uniqueIdentifier]) ||
                    this.scope.showDocumentTypeDropDown;
            };
            FileUploadModalController.prototype.removeDocument = function (index) {
                this.scope.model.documents.splice(index, 1);
                this.scope.model.fileUploadProgress = undefined;
            };
            FileUploadModalController.prototype.uploadFiles = function (files) {
                var _this = this;
                this.scope.model.fileUploadProgress = undefined;
                this.fileUploadDownloadService.uploadFiles(files, this.scope.model).then(function (documents) {
                    _this.scope.model.documents = documents;
                    for (var i = 0; i < _this.scope.model.documents.length; i++) {
                        _this.scope.documentMetadataModel.updateDocumentDto(_this.scope.model.documents[i]);
                    }
                }, function (response) {
                    if (response.status > 0) {
                        _this.scope.model.errorMessage = response.status + ': ' + response.data;
                    }
                }, function (evt) {
                    _this.scope.model.fileUploadProgress = Math.min(100, parseInt((100.0 * evt.loaded / evt.total)));
                });
            };
            FileUploadModalController.prototype.canSave = function () {
                if (this.scope.model.documents && this.scope.model.documents.length > 0) {
                    if (!this.scope.showDocumentTypeDropDown || this.scope.documentMetadataModel.documentTypeUniqueId) {
                        return true;
                    }
                }
                return false;
            };
            return FileUploadModalController;
        }(controllers.BaseModalController));
        controllers.FileUploadModalController = FileUploadModalController;
    })(controllers = warsApp.controllers || (warsApp.controllers = {}));
})(warsApp || (warsApp = {}));
warsApp.registerController("FileUploadModalController", [
    "$scope", "$timeout", "documentIds", "process", "documentConfiguration", "systemDocumentConfiguration", "uniqueIdentifier", "model", "fileUploadDownloadService", "processDocumentService", "close"
]);
